import _classCallCheck from "/Users/ordex_mobile/Desktop/Rushabh/Learning/bet/betlights/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ordex_mobile/Desktop/Rushabh/Learning/bet/betlights/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/ordex_mobile/Desktop/Rushabh/Learning/bet/betlights/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/ordex_mobile/Desktop/Rushabh/Learning/bet/betlights/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ordex_mobile/Desktop/Rushabh/Learning/bet/betlights/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/ordex_mobile/Desktop/Rushabh/Learning/bet/betlights/node_modules/@babel/runtime/helpers/esm/createSuper";
import { RepulseBase } from "./RepulseBase";
export var RepulseDiv = /*#__PURE__*/function (_RepulseBase) {
  _inherits(RepulseDiv, _RepulseBase);
  var _super = _createSuper(RepulseDiv);
  function RepulseDiv() {
    var _this;
    _classCallCheck(this, RepulseDiv);
    _this = _super.call(this);
    _this.selectors = [];
    return _this;
  }
  _createClass(RepulseDiv, [{
    key: "ids",
    get: function get() {
      if (this.selectors instanceof Array) {
        return this.selectors.map(function (t) {
          return t.replace("#", "");
        });
      } else {
        return this.selectors.replace("#", "");
      }
    },
    set: function set(value) {
      if (value instanceof Array) {
        this.selectors = value.map(function () {
          return "#".concat(value);
        });
      } else {
        this.selectors = "#".concat(value);
      }
    }
  }, {
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(RepulseDiv.prototype), "load", this).call(this, data);
      if (data === undefined) {
        return;
      }
      if (data.ids !== undefined) {
        this.ids = data.ids;
      }
      if (data.selectors !== undefined) {
        this.selectors = data.selectors;
      }
    }
  }]);
  return RepulseDiv;
}(RepulseBase);